"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.confirmPhone = confirmPhone;
var _view = require("../../types/view");
var _registration = require("../../types/registration");
var _sentEmail = require("../../types/sentEmail");
var _action_types = require("../../constants/action_types");
var _confirmPhone = require("../../api/confirmPhone");
var _view2 = require("../view");
var _events = require("../../types/events");
var _tracking = require("../../utils/tracking");
function confirmPhone(_ref) {
  let {
    email,
    phone,
    code,
    source
  } = _ref;
  return (dispatch, _getState, context) => {
    dispatch({
      status: _registration.EConfirmPhoneStatus.Loading,
      type: _action_types.REGISTRATION_CONFIRM_PHONE_TYPE
    });
    return (0, _confirmPhone.confirmPhone)(context.httpApi, {
      email,
      phone,
      confirmed: true,
      confirmationCode: code,
      subdomain: context.subdomain
    }).then(response => {
      if (response.statusCode === 200) {
        if (response.response.status.value === _confirmPhone.ESavePhoneStatus.Success) {
          dispatch({
            status: _registration.EConfirmPhoneStatus.Succeed,
            type: _action_types.REGISTRATION_CONFIRM_PHONE_TYPE
          });
          dispatch((0, _view2.changeView)(_view.EActiveView.EmailSent, {
            type: _sentEmail.ESentEmailType.Registration,
            email
          }));
          context.emitter.emit(_events.EEventType.ConfirmPhoneSucceed);
          return;
        } else {
          if (response.response.status.value === _confirmPhone.ESavePhoneStatus.ValidationFailed) {
            (0, _tracking.trackRegistrationSmsValidationFail)(source);
          }
          dispatch({
            status: _registration.EConfirmPhoneStatus.Failed,
            type: _action_types.REGISTRATION_CONFIRM_PHONE_TYPE,
            error: response.response.status.message || 'Произошла непредвиденная ошибка'
          });
          return;
        }
      }
      dispatch({
        status: _registration.EConfirmPhoneStatus.Failed,
        type: _action_types.REGISTRATION_CONFIRM_PHONE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    }).catch(error => {
      context.logger.error(error, {
        domain: 'auth-widget.api.confirmPhone'
      });
      dispatch({
        status: _registration.EConfirmPhoneStatus.Failed,
        type: _action_types.REGISTRATION_CONFIRM_PHONE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}